import React from "react";
import Tip from "../utility/tip";
import QuestionBox from "../utility/question-box";
import MessageBox from "../utility/message-box";
import productStore from "../../store/product-store";
import SelectMenu from "../../components/utility/select-menu";
import tankStore from "../../store/tank-store";
import StockIn from "../../../models/backward-stockin";
import * as stockInAction from "../../actions/stockin-action";
import stockInStore from "../../store/stockin-store";
import { stockInConstant, productConstant, shiftConstant } from "../../constants/constants";
import rq from "../utility/rq.js";
import Spinner from "../utility/spinner";
import shiftStore from "../../store/shift-store";
export default class CreateBackwardStockIn extends React.Component {

    constructor() {
        super();
        this.state = {
            selectMode: "maanualDip",
            productList: productStore.getAll(),
            tankList: tankStore.getAll(),
            shiftList: shiftStore.getAll(),
            propError: {},
            selectedEmployees: [],
            doNotTakeAttendance: true,
            pendingInvoices: [],
            invoice: null,
            showSpinner: false
        };
        this.handleShiftStoreChange = this.handleShiftStoreChange.bind(this);
        this.onInvoiceSelect = this.onInvoiceSelect.bind(this);
        this.onStockInDateTime = this.onStockInDateTime.bind(this);
        this.askQuestion = this.askQuestion.bind(this);
        this.handleFailed = this.handleFailed.bind(this);
        this.onCreated = this.onCreated.bind(this);
        this.handleProductStoreChange = this.handleProductStoreChange.bind(this);
        this.invoiceMenuReset = false;
        this.tankMenuReset = false;
        this.shiftMenuReset = false;
        this.stockIn = new StockIn({});
        this.questionBox = null;
        this.messageBox = null;
        this.radioChange = this.radioChange.bind(this);
    }

    validate(propToCheck, model, value) {
        this[model][propToCheck] = value;
        var propError = Object.assign({}, this.state.propError);
        if (this[model].getErrors()[propToCheck]) {
            propError[propToCheck] = true;
        } else {
            delete propError[propToCheck];
        }
        this.setState({ propError });
        //return propError;
    }

    onBlur(propToCheck, model) {
        var propError = Object.assign({}, this.state.propError);
        if (this[model].getErrors()[propToCheck]) {
            propError[propToCheck] = true;
        } else {
            delete propError[propToCheck];
        }
        this.setState({ propError });
    }

    onKeyUp(propToCheck, model, e) {
        this.validate(propToCheck, model, e.target.value);

    }

    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>
        this.forceUpdate();
    }
    handleCreateStockIn() {
        this.stockIn.checkAtg(this.stockIn.startDipVolume, this.stockIn.endDipVolume, this.stockIn.isAtg);
        this.stockIn.checkDip(this.stockIn.startDip, this.stockIn.endDip);
        this.stockIn.checkReding(this.stockIn.beforeReading, this.stockIn.afterReading);

        if (!this.stockIn.hasError()) {
            this.askQuestion(`Do you watnt to create StockIn ?`, () => {
                this.setState({ showSpinner: true });
                stockInAction.cratedBackWardStockIn(this.stockIn);
                this.questionBox = null;
                this.forceUpdate();
            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        } else {
            let propError = Object.assign({}, this.stockIn.getErrors());
            this.setState({ propError });
        }

    }
    onProductSelect(product) {
        this.setState({ pendingInvoices: [] });
        if (product) {
            this.validate("productId", "stockIn", product.productId);
            let tankList = tankStore.getAll().filter((tank) => {
                return product.productId === tank.productId;
            });

            // making a rq call on product select to get pending invoices by productid
            rq.getJsonData("/api/v1/stockins/pending/" + product.productId).then((data) => {

                this.setState({ pendingInvoices: data });
            }).catch((err) => {
                throw err;
            });
            this.invoiceMenuReset = true;
            this.tankMenuReset = true;
            this.setState({ tankList, invoice: null });
        }
    }

    onTankSelect(tank) {
        this.tankMenuReset = false;
        this.validate("tankId", "stockIn", tank.tankId);
    }
    onShiftSelect(shift) {
        // console.log(shift);
        if (shift) {
            this.selectedShift = shift;
            this.validate("shiftId", "stockIn", shift.shiftId);
            // var propError = Object.assign({}, this.state.propError);
            // propError.selectedShift = false;
            // this.setState({ propError });
        }
    }

    onInvoiceSelect(invoice) {
        if (invoice) {
            this.invoiceMenuReset = false;
            this.stockIn.remaining = invoice.avilabel;
            this.stockIn.invoiceDetailId = invoice.invoiceDetailId;
            var propError = Object.assign({}, this.state.propError);
            propError.remaining = false;
            propError.invoiceDetailId = false;
        }
        this.setState({ invoice, propError });

    }


    onStockInDateTime(e) {
        if (e) {
            let dateTime = e.target.value.replace("T", " ");
            this.validate("stockInDateTime", "stockIn", dateTime);
        }
    }
    handleKeyUp(propToCheck, model, e) {
        this.validate(propToCheck, model, e.target.value);
    }

    handleFailed(msg) {
        this.messageBox = MessageBox.showMessage(msg, false, this);
        this.setState({ showSpinner: false });
    }

    onCreated(msg) {
        this.messageBox = MessageBox.showMessage(msg, true, this);
        this.refs.stockInDateTime.value = "";
        this.refs.startDip.value = "";
        this.refs.endDip.value = "";

        if (this.refs.startDipVolume)
            this.refs.startDipVolume.value = "";

        if (this.refs.startDipVolume)
            this.refs.endDipVolume.value = "";

        this.refs.shiftDate.value = "";
        this.refs.afterReading.value = "";
        this.refs.beforeReading.value = "";
        this.productMenuReset = true;
        this.invoiceMenuReset = true;
        this.shiftMenuReset = true;
        this.tankMenuReset = true;
        this.stockIn = new StockIn({});
        this.setState({ invoice: null, pendingInvoices: [], showSpinner: false });
    }
    handleProductStoreChange() {
        this.state.productList = productStore.getAll();
        this.setState(this.state);
    }
    handleShiftStoreChange() {
        this.setState({ shiftList: shiftStore.getAll() });
    }
    componentWillMount() {
        stockInStore.on(stockInConstant.STOCKIN_CREATED, this.onCreated);
        stockInStore.on(stockInConstant.STOCKIN_CREATION_FAILED, this.handleFailed);

        productStore.on(productConstant.PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
        shiftStore.on(shiftConstant.SHIFT_STORE_CHANGE, this.handleShiftStoreChange);
    }

    componentWillUnmount() {
        stockInStore.removeListener(stockInConstant.STOCKIN_CREATED, this.onCreated);
        stockInStore.removeListener(stockInConstant.STOCKIN_CREATION_FAILED, this.handleFailed);

        productStore.removeListener(productConstant.PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
        shiftStore.removeListener(shiftConstant.SHIFT_STORE_CHANGE, this.handleShiftStoreChange);
    }

    componentDidUpdate() {
        this.productMenuReset = false;
        this.invoiceMenuReset = false;
        this.tankMenuReset = false;
        this.shiftMenuReset = false;
    }
    componentDidMount() {
        this.refs.stockInDateTime.focus();
    }
    radioChange(e) {
        // console.log(e.target.value);
        const isAtg = e.target.value === "atgDip" ? true : false;
        // this.validate("startDipVolume", "stockIn", null);
        // this.validate("endDipVolume", "stockIn", null);
        this.stockIn.startDipVolume = null;
        this.stockIn.endDipVolume = null;
        this.stockIn.isAtg = isAtg;
        this.setState({ selectMode: e.target.value });

    }
    render() {
        return (
            <div>
                <div className="midholder">
                    <p className="formMsg">Create Backward StockIn</p>
                    <div style={{ display: "inline-block", margin: "10px 0 0 20px" }}>
                        <label style={{ cursor: "pointer" }}>
                            <input type="radio" value="maanualDip" checked={this.state.selectMode === "maanualDip"} onChange={this.radioChange} /> Manual Dip
                                    </label>
                        <label style={{ cursor: "pointer" }}>
                            <input type="radio" value="atgDip" checked={this.state.selectMode === "atgDip"} onChange={this.radioChange} /> Atg Dip
                                    </label>

                    </div>
                    <table className="formTable">
                        <tbody>
                            <tr>

                                <td>
                                    <Tip
                                        showOn={this.state.propError.stockInDateTime}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().stockInDateTime}
                                    />
                                    <p className="label">Enter stock in date time</p>
                                    <input
                                        type="datetime-local"
                                        className="formControl inputBox"
                                        ref="stockInDateTime"
                                        onKeyUp={this.onStockInDateTime}
                                        tabIndex="1"
                                    />
                                </td>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.productId}
                                        pointerStyle={{}}
                                        msg={"Select Product"}
                                    />
                                    <p className="label">Select Product</p>
                                    <SelectMenu
                                        data={this.state.productList}
                                        onSelect={this.onProductSelect.bind(this)}
                                        text="Select a product"
                                        tabIndex="2"
                                        ky="productId"
                                        vl="productName"
                                        reset={this.productMenuReset}

                                    />

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="label">Select a shift</p>
                                    <Tip
                                        showOn={this.state.propError.shiftId}
                                        pointerStyle={{}}
                                        msg={"Please select a shift"}
                                    />
                                    <SelectMenu
                                        data={this.state.shiftList}
                                        onSelect={this.onShiftSelect.bind(this)}
                                        text="Select a shift"
                                        tabIndex="3"
                                        ky="shiftId"
                                        vl="shiftName"
                                        reset={this.shiftMenuReset}
                                        rex={(selectMenu) => {
                                            this.selectMenu = selectMenu;
                                        }}
                                    >
                                    </SelectMenu>
                                </td>

                                <td>
                                    <p className="label">Shift  date </p>
                                    <Tip
                                        showOn={this.state.propError.shiftDate}
                                        pointerStyle={{}}
                                        msg={"Please enter a valid shift date "}
                                    />
                                    <input
                                        tabIndex="4"
                                        type="date"
                                        className="formControl inputBox"
                                        ref="shiftDate"
                                        onKeyUp={this.handleKeyUp.bind(this, "shiftDate", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "shiftDate", "stockIn")}

                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.invoiceDetailId}
                                        pointerStyle={{}}
                                        msg={"Select Invoice"}
                                    />
                                    <p className="label">Select Invoice</p>
                                    <SelectMenu
                                        data={this.state.pendingInvoices}
                                        onSelect={this.onInvoiceSelect.bind(this)}
                                        text="Select a invoice"
                                        tabIndex="5"
                                        ky="invoiceDetailId"
                                        vl="invoiceNumber"

                                        reset={this.invoiceMenuReset}
                                    />
                                </td>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.tankId}
                                        pointerStyle={{}}
                                        msg={"Select Tank"}
                                    />
                                    <p className="label">Select Tank</p>
                                    <SelectMenu
                                        data={this.state.tankList}
                                        onSelect={this.onTankSelect.bind(this)}
                                        text="Select a tank"
                                        tabIndex="6"
                                        ky="tankId"
                                        vl="tankName"
                                        reset={this.tankMenuReset}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.startDip}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().startDip}
                                    />
                                    <p className="label">Start Dip</p>
                                    <input
                                        type="number"
                                        ref="startDip"
                                        className="formControl inputBox"
                                        placeholder="Start Dip"
                                        tabIndex="7"
                                        onKeyUp={this.handleKeyUp.bind(this, "startDip", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "startDip", "stockIn")}
                                    />
                                </td>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.endDip}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().endDip}
                                    />
                                    <p className="label">End Dip</p>
                                    <input
                                        type="number"
                                        ref="endDip"
                                        placeholder="End Dip"
                                        tabIndex="8"
                                        className="formControl inputBox"
                                        onKeyUp={this.handleKeyUp.bind(this, "endDip", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "endDip", "stockIn")}
                                    />
                                </td>

                            </tr >
                            {this.state.selectMode === "atgDip" ? <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.startDipVolume}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().startDipVolume}
                                    />
                                    <p className="label">Start Dip Volume</p>
                                    <input
                                        type="number"
                                        ref="startDipVolume"
                                        className="formControl inputBox"
                                        placeholder="Start Dip Volume"
                                        tabIndex="9"
                                        onKeyUp={this.handleKeyUp.bind(this, "startDipVolume", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "startDipVolume", "stockIn")}
                                    />
                                </td>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.endDipVolume}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().endDipVolume}
                                    />
                                    <p className="label">End Dip Volume</p>
                                    <input
                                        type="number"
                                        ref="endDipVolume"
                                        placeholder="End Dip Volume"
                                        tabIndex="10"
                                        className="formControl inputBox"
                                        onKeyUp={this.handleKeyUp.bind(this, "endDipVolume", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "endDipVolume", "stockIn")}
                                    />
                                </td>

                            </tr > : false}
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.beforeReading}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().beforeReading}
                                    />
                                    <p className="label">Enter Before Reading Sum</p>
                                    <input
                                        type="number"
                                        ref="beforeReading"
                                        className="formControl inputBox"
                                        placeholder="Enter Before Reading Sum"
                                        tabIndex="11"
                                        onKeyUp={this.handleKeyUp.bind(this, "beforeReading", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "beforeReading", "stockIn")}
                                    />
                                </td>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.afterReading}
                                        pointerStyle={{}}
                                        msg={this.stockIn.getErrors().afterReading}
                                    />
                                    <p className="label">Enter after Reading Sum</p>
                                    <input
                                        type="number"
                                        ref="afterReading"
                                        placeholder="Enter After Reading Sum"
                                        tabIndex="12"
                                        className="formControl inputBox"
                                        onKeyUp={this.handleKeyUp.bind(this, "afterReading", "stockIn")}
                                        onBlur={this.handleKeyUp.bind(this, "afterReading", "stockIn")}
                                    />
                                </td>

                            </tr >
                            {this.state.invoice ? <tr
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "start"
                                }}
                            >
                                <td>
                                    <p className="label">Ordered Quantity</p>
                                    <p className="val" >{this.state.invoice.orederQuantity / 1000} KL</p>
                                </td>
                                <td>
                                    <p className="label">Shortage Quantity</p>
                                    <p className="val" >{this.state.invoice.shortageQuantity} Ltrs</p>
                                </td>
                                <td>
                                    <p className="label">Remaining Quantity</p>
                                    <p className="val">{this.state.invoice.avilabel / 1000} KL</p>
                                </td>
                                <td>
                                    <div style={{
                                        position: "absolute",
                                        left: "-7px",
                                        bottom: "-5px",
                                        width: "400px"
                                    }}>
                                        <Tip
                                            showOn={this.state.propError.quantity}
                                            pointerStyle={{}}
                                            msg={this.stockIn.getErrors().quantity}
                                        />
                                    </div>
                                    <p className="label">Stock in Quantity KL</p>
                                    <input type="text"
                                        ref="quantity"
                                        tabIndex="13"
                                        onKeyUp={this.handleKeyUp.bind(this, "quantity", "stockIn")}
                                        style={{ marginTop: "5px", textAlign: "center", width: "90px", padding: "5px", display: "block" }}
                                    />

                                </td>
                            </tr> : null}
                        </tbody>

                    </table>

                    <button
                        className="btn btnOk btnRight"
                        tabIndex="14"
                        onClick={this.handleCreateStockIn.bind(this)}
                        style={{ marginRight: "50px", display: "flex", alignSelf: "flex-end" }}
                    >
                        Submit
                    </button>
                    <div className="clear"></div>
                </div>
                {this.state.showSpinner ? <Spinner></Spinner> : null}
                {this.questionBox}
                {this.messageBox}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/jsx/components/fragments/backward-stockin.jsx